module.exports = __webpack_public_path__ + "img/icon_09.b4b5a742.png";